<template>
    <b-card no-body>
        <div>
            <v-table ref="table" :items-provider="provider" :fields="fields" :buttons="buttons" search pagination="server" with-items>
                <template #additional-actions>
                    <div class="row align-items-end">
                        <div class="col-md-5 col-12 mb-1 mb-md-0">
                            <v-date-picker id="order-datepicker" v-model="dateRange" range placeholder="Tarih Aralığı Seçin"></v-date-picker>
                        </div>
                        <div class="col-auto">
                            <b-button variant="primary" @click="fetchFromTicimax" :disabled="isSyncing">
                                <feather-icon icon="RefreshCwIcon" class="mr-50" />
                                <span v-if="isSyncing">Getiriliyor...</span>
                                <span v-else>Ticimax'tan Getir</span>
                            </b-button>
                        </div>
                    </div>
                </template>
            </v-table>
        </div>
    </b-card>
</template>

<script>
import { BCard, BButton } from "bootstrap-vue";
import { B2BOrderApi } from "@/api/b2b-order";
// import OrdersFilter from './components/OrdersFilter.vue'
// import SyncOrdersModal from './components/SyncOrdersModal.vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    components: {
        BCard,
        BButton,
        // OrdersFilter,
        // SyncOrdersModal,
    },
    data() {
        return {
            fields: [
                { name: "Sipariş No", key: "SiparisNo", sortable: false, thClass: "w-10", tdClass: "text-nowrap" },
                { name: "Sipariş Tarihi", key: "SiparisTarihi", thClass: "w-15", tdClass: "text-nowrap" },
                { name: "Cari Kodu", key: "CariKodu", thClass: "w-15", tdClass: "text-nowrap" },
                { name: "Cari Adı", key: "CariAdi", thClass: "w-15", tdClass: "text-nowrap" },
                { name: "Sipariş Durumu", key: "SiparisDurumu", thClass: "w-15" },
                { name: "Toplam Tutar", key: "SiparisToplamTutari", thClass: "w-15", tdClass: "text-right" },
                { name: "Toplam KDV", key: "ToplamKdv", thClass: "w-15", tdClass: "text-right" },
                { name: "İndirim Tutarı", key: "IndirimTutari", thClass: "w-15", tdClass: "text-right" },
                { name: "Netsis'e Aktarıldı", key: "NetsiseAktarildi", thClass: "w-10", tdClass: "text-center" },
            ],
            buttons: [
                {
                    key: "view-details",
                    icon: "EyeIcon",
                    text: "Detay",
                    variant: "info",
                    action: (item) => this.goToDetails(item),
                },
            ],
            dateRange: [],
            filterData: {
                BasTar: null,
                BitTar: null,
            },
            isSyncing: false,
        };
    },
    watch: {
        dateRange(newRange) {
            if (newRange && newRange.length === 2) {
                this.refreshTable();
            }
        },
    },
    created() {
        this.setDefaultDates();
    },
    methods: {
        formatDateForApi(date) {
            if (!date) return null;
            const d = new Date(date);
            const year = d.getFullYear();
            const month = ("0" + (d.getMonth() + 1)).slice(-2);
            const day = ("0" + d.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        },
        setDefaultDates() {
            const today = new Date();
            const ninetyDaysAgo = new Date();
            ninetyDaysAgo.setDate(today.getDate() - 90);

            this.dateRange = [this.formatDateForApi(ninetyDaysAgo), this.formatDateForApi(today)];

            this.$nextTick(() => {
                this.refreshTable();
            });
        },

        refreshTable() {
            if (!this.dateRange || this.dateRange.length < 2) return;

            const [startDate, endDate] = this.dateRange;

            const end = new Date(endDate);
            end.setDate(end.getDate() + 1);

            this.filterData = {
                BasTar: this.formatDateForApi(startDate),
                BitTar: this.formatDateForApi(end),
            };

            if (this.$refs.table) {
                this.$refs.table.refresh();
            }
        },

        fetchFromTicimax() {
            if (!this.dateRange || this.dateRange.length < 2) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: "Uyarı",
                        text: "Lütfen geçerli bir tarih aralığı seçin.",
                        icon: "AlertTriangleIcon",
                        variant: "warning",
                    },
                });
                return;
            }

            const [startDate, endDate] = this.dateRange;
            const start = new Date(startDate);
            const end = new Date(endDate);
            const differenceInTime = end.getTime() - start.getTime();
            const differenceInDays = differenceInTime / (1000 * 3600 * 24);
            const maxDaysLimit = 90;

            if (differenceInDays > maxDaysLimit) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: "Uyarı",
                        text: `Ticimax için en fazla ${maxDaysLimit} günlük bir aralık seçebilirsiniz.`,
                        icon: "AlertCircleIcon",
                        variant: "warning",
                    },
                });
                return;
            }

            const endForApi = new Date(endDate);
            endForApi.setDate(endForApi.getDate() + 1);

            const StartDate = this.formatDateForApi(startDate);
            const EndDate = this.formatDateForApi(endForApi);

            this.isSyncing = true;
            B2BOrderApi.fetchOrdersFromTicimax({ StartDate, EndDate })
                .then((res) => {
                    const rawItems = res.data;
                    console.log(`BAŞARILI: Ticimax'tan ${rawItems.length} adet sipariş çekildi.`);
                    const formattedItems = this.formatTicimaxOrderItems(rawItems);
                    this.$refs.table.setItems(formattedItems);
                    this.$refs.table.setTotal(formattedItems.length);
                })
                .catch((err) => console.error("Sync error:", err))
                .finally(() => {
                    this.isSyncing = false;
                });
        },
        goToDetails(item) {
            const routeName = item.isFromTicimax ? "b2b-ticimax-order-detail" : "b2b-order-detail";

            this.$router.push({ name: routeName, params: { id: item.SiparisNo, orderData: item.__original } });
        },

        formatDbOrderItems(items) {
            if (!items || !items.length) return [];
            return items.map((item) => ({
                ...item,
                __original: item,
                SiparisTarihi: new Date(item.SiparisTarihi).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }),
                SiparisToplamTutari: "₺" + item.SiparisToplamTutari.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                ToplamKdv: "₺" + item.ToplamKdv.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                IndirimTutari: "₺" + item.IndirimTutari.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }));
        },

        formatTicimaxOrderItems(items) {
            if (!items || !items.length) return [];
            return items.map((o) => ({
                ...o,
                isFromTicimax: true,
                __original: o,
                SiparisNo: o.SiparisNo,
                SiparisTarihi: new Date(o.SiparisTarihi).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }),
                CariKodu: o.CariKodu || "-",
                CariAdi: o.FaturaAdresi?.FirmaAdi?.trim() || o.AdiSoyadi?.trim() || "-",
                SiparisDurumu: o.SiparisDurumu,
                SiparisToplamTutari: "₺" + o.SiparisToplamTutari.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                ToplamKdv: "₺" + o.ToplamKdv.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                IndirimTutari: "₺" + o.IndirimTutari.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                NetsiseAktarildi: o.EntegrasyonAktarildi,
            }));
        },

        provider(data) {
            const requestData = { ...data, ...this.filterData };
            return B2BOrderApi.getListB2BOrder(requestData).then((response) => {
                if (response.data.Data) {
                    const paginatedData = response.data.Data;
                    const formattedItems = this.formatDbOrderItems(paginatedData.Items);
                    return {
                        data: { Data: { Data: formattedItems, TotalCount: paginatedData.Count } },
                    };
                }
                return { data: { Data: { Data: [], TotalCount: 0 } } };
            });
        },
    },
};
</script>

<style></style>
